import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import BaseNewAndDetail from '../utility/outlines/BaseNewAndDetail';
import { useToken } from '../../utility';
import { failsTokenAndSetupCheck } from '../../checks/setup';
import useThemeVal from '../../utility/useThemeVal';
import _TransferTab from './Tabs/_TransferTab';

const baseEntityName = 'Transfer';
const baseEndpointCheck = false;

const mainKey = 'transfer';

const tabEntityMap = [{ key: mainKey, label: 'Transfer', defaultForDetail: true }];

// TODO: check this
const Transfer = () => {
  const { token, tokenDetails, permissions } = useToken();
  const currDarkThemeClass = useThemeVal();

  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  const invalidTokenState = useMemo(() => failsTokenAndSetupCheck(token, tokenDetails), [token]);

  if (invalidTokenState) return null;

  const tabContentMap = {
    [mainKey]: <_TransferTab currDarkThemeClass={currDarkThemeClass} />,
  };

  const getDefaultTabForEndpoint = () => tabEntityMap?.find(t => t?.defaultForDetail)?.key;

  const showSaveBtn = () => false;
  const toDisable = () => true;

  const baseProps = {
    baseEntityName,
    tabEntityMap,
    tabContentMap,
    baseEndpointCheck,
    getDefaultTabForEndpoint,
    showSaveBtn,
    toDisable,
    currDarkThemeClass,
  };

  return <BaseNewAndDetail {...baseProps} />;
};

export default Transfer;
